var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtNodeTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#E5F6FF",
    stroke: "#1276D3",
    strokeDasharray: "1 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59969 8H14.4036C14.7339 8 15.0033 8.26844 15.0033 8.59764V17.1045C15.0033 17.4337 14.7339 17.7021 14.4036 17.7021H8.99361C8.99881 17.6437 9.00164 17.5849 9.00164 17.5255C9.00164 16.4348 8.11368 15.5499 7.01921 15.5499C5.92474 15.5499 5.03678 16.4348 5.03678 17.5255C5.03678 17.5849 5.03961 17.6437 5.04481 17.7021H3.59969C3.26937 17.7021 3 17.4337 3 17.1045V8.59764C3 8.26844 3.26937 8 3.59969 8Z",
    fill: "#1192E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4003 17.7021H21.364C21.3691 17.6437 21.372 17.5849 21.372 17.5255C21.372 16.4348 20.484 15.5499 19.3896 15.5499C18.2951 15.5499 17.4071 16.4348 17.4071 17.5255C17.4071 17.5849 17.41 17.6437 17.4152 17.7021H16.3788C16.049 17.7021 15.7791 17.4337 15.7791 17.1045V10.3251C15.7791 9.99591 16.0485 9.72746 16.3788 9.72746H18.7502C18.9156 9.72746 19.0578 9.7868 19.1745 9.90266L22.8242 13.5394C22.9409 13.6552 23 13.7979 23 13.9623V17.1045C23 17.4332 22.7297 17.7021 22.4003 17.7021V17.7021ZM21.4075 13.48L18.6014 10.684H16.739V13.48H21.4075V13.48Z",
    fill: "#1192E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3896 16.0416C20.2119 16.0416 20.8787 16.7061 20.8787 17.5256C20.8787 18.345 20.2119 19.0095 19.3896 19.0095C18.5674 19.0095 17.9006 18.345 17.9006 17.5256C17.9006 16.7061 18.5674 16.0416 19.3896 16.0416ZM19.3895 17.0056C19.6778 17.0056 19.9112 17.2383 19.9112 17.5255C19.9112 17.8128 19.6778 18.0455 19.3895 18.0455C19.1012 18.0455 18.8678 17.8128 18.8678 17.5255C18.8678 17.2383 19.1012 17.0056 19.3895 17.0056Z",
    fill: "#1192E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01916 16.0416C7.84143 16.0416 8.50823 16.7061 8.50823 17.5256C8.50823 18.345 7.84143 19.0095 7.01916 19.0095C6.19689 19.0095 5.53009 18.345 5.53009 17.5256C5.53009 16.7061 6.19689 16.0416 7.01916 16.0416ZM7.01916 17.0056C7.30743 17.0056 7.54088 17.2383 7.54088 17.5255C7.54088 17.8128 7.30743 18.0455 7.01916 18.0455C6.73089 18.0455 6.49744 17.8128 6.49744 17.5255C6.49744 17.2383 6.73089 17.0056 7.01916 17.0056V17.0056Z",
    fill: "#1192E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtNodeTruck);
export default __webpack_public_path__ + "static/media/AtNodeTruck.47833b0698fab4c786233c9e7bc90e90.svg";
export { ForwardRef as ReactComponent };